import React from 'react';
import Quantitative_AreaIndicatorChart from "./Quantitative_AreaIndicatorChart";
import DimQuantitative_AreaIndicatorChart from './DimQuantitative_AreaIndicatorChart';
import Qualitative_AreaIndicatorChart from './Qualitative_AreaIndicatorChart';

const ComponentMap = {
    'QUANTITATIVE': Quantitative_AreaIndicatorChart,
    'QUANTITATIVE_DIMENSIONAL': DimQuantitative_AreaIndicatorChart,
    'QUALITATIVE': Qualitative_AreaIndicatorChart,
};

const AreaIndicatorChartFactory = ({ areaIndicator }) => {
    const ChartComponent = ComponentMap[areaIndicator.indicatorDTO.indicatorType];

    if (!ChartComponent) {
        console.error(`No component found for type: ${areaIndicator.indicatorDTO.indicatorType}`);
        return null;
    }

    return <ChartComponent areaIndicator={areaIndicator} />;
};

export default AreaIndicatorChartFactory;